import { cn } from '@repo/ui/lib/utils';
import React from 'react'

function Heading2({ children,className }: { children:React.ReactNode,className?:string }) {
  return (
    <h2 className={cn("text-3xl text-primary lg:text-4xl",className)}>
      {children}
    </h2>
  );
}

export default Heading2;
